import React, {useEffect, useState} from "react";
import styled from "styled-components";
import Button from "../common/Button";
import {toast} from "react-toastify";
import {ModalBody} from "./Modal";
import axios from "axios";
import {useStore} from "../../app/store";

const PreviewModal = ({content, subContent, captureContent, handleCloseModal}) => {
    const {appEditorStore, modalStore} = useStore();
    const [selectedDevice, setSelectedDevice] = useState('pc');
    useEffect(() => {
        const messageHandler = function (e) {
            const messageData = e.data;
            // const {id, height} = e.data;
            if (messageData.id === "andar-detail-page") {
                const iframe = document.getElementById(messageData.id);
                iframe.style.height = messageData.height + 'px';
            }
            if (messageData.id === "move-scroll") {
                // const iframe = document.getElementById("andar-detail-page");
                // const iframeWindow = iframe.contentWindow;
                // iframeWindow.scroll({top: 95, behavior: 'smooth'});
                // iframeWindow.scrollTo({top: 95, behavior: 'smooth'});
                const selector = messageData.selector;
                if (!selector) return;
                const el = document.querySelector(selector);
                if (el) {
                    el.scrollIntoView({behavior: 'smooth', block: 'start'});
                }
            }
            if (messageData.id === 'capture') {
                const dataUrl = messageData.dataUrl
                const link = document.createElement('a');
                link.href = dataUrl;
                link.download = `${selectedDevice}-capture.png`;
                link.click();
            }

            // if (messageData.id === "move-scroll") {
            //     const iframe = document.getElementById("andar-detail-page");
            //     iframe.contentWindow.scrollTo(0, 95);
            // iframe.scrollIntoView({behavior: 'smooth', block: 'start'});
            // }


            //     const iframe = document.getElementById(id);
            // iframe.style.height = height + 'px';
        };
        window.addEventListener('message', messageHandler)
        return () => {
            window.removeEventListener('message', messageHandler);
        }
    }, []);
    const resizeIframe = (iframe, width) => {
        if (iframe && width) {
            iframe.style.width = `${width}px`;
        }
        const iframeDocument = iframe.contentDocument;
        if (!iframeDocument) return;
        const contentHeight = iframeDocument.documentElement.getBoundingClientRect().height;
        if (iframe) {
            iframe.style.height = `${contentHeight}px`;
        }
    };

    if (content.length === 0) {
        return;
    }

    return (
        <ModalBody id={"PreviewEditorModal"}>
            <EditPreviewWarp className={"preview-modal"}>

                <div className="code-copy-btn-wrap">


                    {
                        appEditorStore.boardTree.filter((tree) => tree.data.isFitGuide).length > 0 &&
                        <Button
                            type={"fill"}
                            size={"m"}
                            text={`기장 가이드 미리보기`}
                            className={"mr-3 spec-view"}
                            onClickFunc={async () => {
                                const content = await appEditorStore.getFitGuideHtml();
                                // modalStore.openModal({...modalStore.MODAL_PAYLOAD.FIT_GUIDE_PREIVEW(content, selectedDevice)}, null);
                                modalStore.openModal({
                                    ...modalStore.MODAL_PAYLOAD.FIT_GUIDE_PREIVEW(content, selectedDevice),
                                    closeFunc: (callback) => {
                                        const iframe = document.getElementById("andar-detail-page");
                                        resizeIframe(iframe, selectedDevice === "pc" ? 775 : 400);
                                        callback();
                                    }
                                }, null);
                            }}
                        />
                    }


                    <Button
                        type={"fill"}
                        size={"m"}
                        text={`이미지 추출`}
                        className={"mr-3 spec-view"}
                        onClickFunc={async () => {
                            try {
                                appEditorStore.setCaptureLoad(true);
                                const targetWidth = selectedDevice === 'pc' ? 775 : 400;
                                const response = await axios.post('/page/convertImage', {
                                    source: captureContent,
                                    width: targetWidth
                                }, {responseType: 'blob'});
                                const blob = new Blob([response.data], {type: 'image/jpeg'});
                                const url = URL.createObjectURL(blob);
                                const link = document.createElement('a');
                                link.href = url;
                                link.download = `${selectedDevice}-editor-capture.jpg`;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                URL.revokeObjectURL(url);
                                toast("이미지 추출이 완료 되었습니다.");
                            } catch (e) {
                                console.log(e);
                            }
                            appEditorStore.setCaptureLoad(false);

                        }}
                    />
                    <Button
                        type={"fill"}
                        size={"m"}
                        text={"통합 코드 복사"}
                        onClickFunc={() => {
                            // const convertContent = subContent.replaceAll(`\n<script type="text/javascript" src="${import.meta.env.VITE_CLOUDFRONT_URL}/scripts/iframeResize.js"></script>`, "")
                            navigator.clipboard.writeText(subContent);
                            toast("통합 코드가 복사되었습니다.", {autoClose: 1000});
                        }}
                    />
                </div>

                <div className="preview-content-container">
                    <div className="nav-tab-wrap">
                        <div className={`nav ${selectedDevice === 'pc' ? 'active' : ''}`} onClick={() => {
                            setSelectedDevice('pc');
                            const iframe = document.getElementById("andar-detail-page");
                            resizeIframe(iframe, 775);
                        }}>
                            <span>PC</span>
                        </div>
                        <div className={`nav ${selectedDevice === 'mo' ? 'active' : ''}`} onClick={() => {
                            setSelectedDevice('mo');
                            const iframe = document.getElementById("andar-detail-page");
                            resizeIframe(iframe, 400);
                        }}>
                            <span>Mobile</span>
                        </div>
                    </div>
                    <div className="preview-content-wrapper">
                        {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
                        <iframe className={"preview-modal-inner-iframe"}
                                id={"andar-detail-page"}
                                srcDoc={content}
                                onLoad={(e) => {
                                    resizeIframe(e.target)
                                }}
                        >
                        </iframe>
                    </div>
                </div>
            </EditPreviewWarp>
        </ModalBody>
    );
};


const EditPreviewWarp = styled.article`

    margin: 0 auto;
    overflow: hidden;
    background-color: #f5f5f5;
    padding: 32px;

    div.code-copy-btn-wrap {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        //.spec-view {
        //    display: none;
        //}
    }

    div.preview-content-container {
        margin-top: 16px;

        div.preview-content-wrapper {
            height: 600px;
            background-color: #fff;
            padding: 0 28px;
            overflow: auto;
            position: relative;
            display: flex;

            img {
                max-width: 100%;
            }

            .preview-modal-inner-iframe {
                margin: 0 auto;
                width: 775px; // pc 기준으로 잡음
            }
        }

        div.nav-tab-wrap {
            display: flex;
            align-items: center;
            border: 1px solid var(--line-table-section-line, #eee);

            div.nav {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 44px;
                width: 50%;
                background-color: var(--disabled-bg-colored, #f5f5f5);

                span {
                    color: var(--enabled-lgt, #b0b0b0);
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 20px;
                    letter-spacing: -0.28px;
                }

                &.active {
                    background-color: var(--txt-table-label, #555);

                    span {
                        color: var(--White_-FFFFFF, #fff);
                    }
                }
            }
        }
    }
`;


export default PreviewModal;
